export default "__VITE_ASSET__CIuqm9jd__"